module.exports = __webpack_public_path__ + "img/image1.be928729.jpeg";